import { FormItem, NumberInput } from '@framework/form';
import { yup } from '@framework/validation';
import React from 'react';
import { IWidgetComponentProps } from '../../../IWidgetType';
import { WidgetType } from '../../../Widget';
import {
  CommonConfigComponent,
  CommonInputWidgetConfigSchema,
} from '../common/CommonInputConfigComponent';
import { ICurrencyWidget } from './ICurrencyWidget';

export const currencyInputConfigValidator = CommonInputWidgetConfigSchema.shape(
  {
    type: yup.string().exact(WidgetType.Currency).required(),
    decimalSize: yup
      .number()
      .min(0)
      .notRequired()
      .nullable()
      .label('Numero massimo cifre decimali'),
  },
) satisfies yup.ObjectSchema<ICurrencyWidget>;

export interface ICurrencyWidgetConfigComponentProps
  extends IWidgetComponentProps<ICurrencyWidget> {}

export function CurrencyWidgetConfigComponent(
  props: ICurrencyWidgetConfigComponentProps,
) {
  return (
    <>
      <CommonConfigComponent {...props} />
      <FormItem name="decimalSize" label="Numero massimo cifre decimali">
        <NumberInput name="decimalSize" allowClear min={0} />
      </FormItem>
    </>
  );
}
